import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AdminService } from '../services/admin/admin.service';
import { FormControl } from '@angular/forms';

// Declarar Chart como variable global
declare var Chart: any;

@Component({
  selector: 'app-analiticas',
  templateUrl: './analiticas.component.html',
  styleUrls: ['./analiticas.component.css']
})
export class AnaliticasComponent implements OnInit, AfterViewInit, OnDestroy {

  // Gráficas
  public impressionsChart: any = null;
  public clicksChart: any = null;
  public conversionChart: any = null;

  // Loading states
  showLoading = false;
  showElementLoading = false;

  // Form controls
  analyticsTypeFilter: FormControl = new FormControl('popups');
  elementFilter: FormControl = new FormControl('all');
  dateFilter: FormControl = new FormControl(new Date().getFullYear());

  // Data arrays
  popupsList: any[] = [];
  bannersList: any[] = [];
  currentElementList: any[] = [];

  // Analytics data
  analyticsData: any = {};
  summaryMetrics: any = {};

  // Chart configuration
  meses = [
    'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN',
    'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'
  ];

  // Chart selection
  chartSelection = 1; // 1: Impresiones, 2: Clicks, 3: Conversiones

  // Analytics types
  analyticsTypes = [
    { value: 'popups', label: 'Popups' },
    { value: 'banners', label: 'Banners' }
  ];

  constructor(private adminService: AdminService) {
    // Constructor completamente vacío
  }

  ngOnInit() {
    this.initializeFilters();
    this.loadElementsLists();
  }

  ngAfterViewInit() {
    // Verificar que Chart esté disponible
    if (typeof Chart !== 'undefined') {
      setTimeout(() => {
        this.loadAnalytics();
      }, 100);
    } else {
      console.error('Chart.js no está disponible');
    }
  }

  ngOnDestroy() {
    this.destroyExistingCharts();
  }

  loadElementsLists() {
    // Cargar popups
    this.adminService.listPopups(1, 100).subscribe(
      (response: any) => {
        if (Array.isArray(response)) {
          this.popupsList = response;
        } else {
          this.popupsList = response.results || [];
        }
        this.updateCurrentElementList();
      },
      error => {
        console.error('Error cargando popups:', error);
        this.popupsList = [];
        this.updateCurrentElementList();
      }
    );

    // Cargar banners
    this.adminService.listBanners(1, 100).subscribe(
      (response: any) => {
        if (Array.isArray(response)) {
          this.bannersList = response;
        } else {
          this.bannersList = response.results || [];
        }
        this.updateCurrentElementList();
      },
      error => {
        console.error('Error cargando banners:', error);
        this.bannersList = [];
        this.updateCurrentElementList();
      }
    );
  }

  updateCurrentElementList() {
    if (this.analyticsTypeFilter.value === 'popups') {
      this.currentElementList = this.popupsList;
    } else {
      this.currentElementList = this.bannersList;
    }
  }
  loadSampleData() {
    this.analyticsData = {
      summary: {
        total_views: 150,
        total_clicks: 45,
        total_conversions: 8,
        total_popups: 4,
        active_popups: 4
      },
      analytics: [
        { popup_name: 'Popup 1', total_views: 50, total_clicks: 15, active: true },
        { popup_name: 'Popup 2', total_views: 40, total_clicks: 12, active: true },
        { popup_name: 'Popup 3', total_views: 35, total_clicks: 10, active: true },
        { popup_name: 'Popup 4', total_views: 25, total_clicks: 8, active: true }
      ]
    };

    this.processAnalyticsData(this.analyticsData);
    setTimeout(() => {
      this.generateCharts();
    }, 100);
  }

  loadPopupAnalytics(elementId: string, year: string) {
    if (elementId === 'all') {
      return this.adminService.getPopupAnalytics(year);
    } else {
      return this.adminService.getPopupAnalyticsById(parseInt(elementId), year);
    }
  }

  loadBannerAnalytics(elementId: string, year: string) {
    if (elementId === 'all') {
      return this.adminService.getBannerAnalytics(year);
    } else {
      return this.adminService.getBannerAnalyticsById(parseInt(elementId), year);
    }
  }

  processAnalyticsData(data: any) {
    this.analyticsData = data;

    if (data.banner_name || data.popup_name || (data.hasOwnProperty('total_clicks') && !data.hasOwnProperty('analytics'))) {
      this.processIndividualElementData(data);
    } else if (data.summary) {
      this.processGeneralData(data);
    } else {
      this.initializeDefaultMetrics();
    }
  }

  processIndividualElementData(data: any) {
    const isBannerData = data.hasOwnProperty('banner_name');
    const isPopupData = data.hasOwnProperty('popup_name');

    if (isBannerData) {
      const estimatedConversions = this.calculateEstimatedConversions(data.total_clicks || 0);
      this.summaryMetrics = {
        totalImpressions: data.unique_users || 0,
        totalClicks: data.total_clicks || 0,
        totalConversions: estimatedConversions,
        conversionRate: this.calculateConversionRate(estimatedConversions, data.unique_users || 0),
        clickThroughRate: this.calculateClickThroughRate(data.total_clicks || 0, data.unique_users || 0),
        totalElements: 1,
        activeElements: data.active ? 1 : 0,
        uniqueUsers: data.unique_users || 0,
        dataType: 'banners',
        elementName: data.banner_name || 'Banner'
      };
    } else if (isPopupData) {
      const estimatedConversions = this.calculateEstimatedConversions(data.total_clicks || 0);
      this.summaryMetrics = {
        totalImpressions: data.total_views || 0,
        totalClicks: data.total_clicks || 0,
        totalConversions: estimatedConversions,
        conversionRate: this.calculateConversionRate(estimatedConversions, data.total_views || 0),
        clickThroughRate: this.calculateClickThroughRate(data.total_clicks || 0, data.total_views || 0),
        totalElements: 1,
        activeElements: data.active ? 1 : 0,
        uniqueUsers: 0,
        dataType: 'popups',
        elementName: data.popup_name || 'Popup'
      };
    } else {
      const hasUniqueUsers = data.hasOwnProperty('unique_users');
      const estimatedConversions = this.calculateEstimatedConversions(data.total_clicks || 0);

      this.summaryMetrics = {
        totalImpressions: hasUniqueUsers ? data.unique_users : (data.total_views || 0),
        totalClicks: data.total_clicks || 0,
        totalConversions: estimatedConversions,
        conversionRate: this.calculateConversionRate(estimatedConversions, hasUniqueUsers ? data.unique_users : data.total_views),
        clickThroughRate: this.calculateClickThroughRate(data.total_clicks || 0, hasUniqueUsers ? data.unique_users : data.total_views),
        totalElements: 1,
        activeElements: data.active ? 1 : 0,
        uniqueUsers: data.unique_users || 0,
        dataType: hasUniqueUsers ? 'banners' : 'popups',
        elementName: data.name || 'Elemento'
      };
    }
  }

  processGeneralData(data: any) {
    const isPopupData = data.summary.hasOwnProperty('total_views');
    const isBannerData = data.summary.hasOwnProperty('total_unique_users');

    if (isPopupData) {
      const estimatedConversions = this.calculateEstimatedConversions(data.summary.total_clicks || 0);

      this.summaryMetrics = {
        totalImpressions: data.summary.total_views || 0,
        totalClicks: data.summary.total_clicks || 0,
        totalConversions: estimatedConversions,
        conversionRate: this.calculateConversionRate(estimatedConversions, data.summary.total_views || 0),
        clickThroughRate: this.calculateClickThroughRate(data.summary.total_clicks || 0, data.summary.total_views || 0),
        totalElements: data.summary.total_popups || 0,
        activeElements: data.summary.active_popups || 0,
        uniqueUsers: 0,
        dataType: 'popups'
      };
    } else if (isBannerData) {
      const estimatedConversions = this.calculateEstimatedConversions(data.summary.total_clicks || 0);

      this.summaryMetrics = {
        totalImpressions: data.summary.total_unique_users || 0,
        totalClicks: data.summary.total_clicks || 0,
        totalConversions: estimatedConversions,
        conversionRate: this.calculateConversionRate(estimatedConversions, data.summary.total_unique_users || 0),
        clickThroughRate: this.calculateClickThroughRate(data.summary.total_clicks || 0, data.summary.total_unique_users || 0),
        totalElements: data.summary.total_banners || 0,
        activeElements: data.summary.active_banners || 0,
        uniqueUsers: data.summary.total_unique_users || 0,
        dataType: 'banners'
      };
    }
  }

  initializeDefaultMetrics() {
    this.summaryMetrics = {
      totalImpressions: 0,
      totalClicks: 0,
      totalConversions: 0,
      conversionRate: 0,
      clickThroughRate: 0,
      totalElements: 0,
      activeElements: 0,
      uniqueUsers: 0,
      dataType: 'unknown'
    };
  }

  calculateConversionRate(conversions: number, views: number): number {
    if (!views || views === 0) return 0;
    return (conversions / views) * 100;
  }

  calculateClickThroughRate(clicks: number, views: number): number {
    if (!views || views === 0) return 0;
    return (clicks / views) * 100;
  }

  calculateEstimatedConversions(clicks: number): number {
    return Math.floor(clicks * 0.05);
  }

  processMonthlyData(analyticsData: any, metric: string): number[] {
    const data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    if (analyticsData.banner_name || analyticsData.popup_name ||
      (analyticsData.hasOwnProperty('total_clicks') && !analyticsData.hasOwnProperty('analytics'))) {
      this.distributeIndividualDataAcrossMonths(analyticsData, metric, data);
    } else if (analyticsData && analyticsData.analytics && Array.isArray(analyticsData.analytics)) {
      analyticsData.analytics.forEach((item: any) => {
        this.distributeIndividualDataAcrossMonths(item, metric, data);
      });
    }

    return data;
  }

  distributeIndividualDataAcrossMonths(item: any, metric: string, data: number[]) {
    let totalValue = 0;

    if (metric === 'impressions') {
      totalValue = item.total_views || item.unique_users || 0;
    } else if (metric === 'clicks') {
      totalValue = item.total_clicks || 0;
    } else if (metric === 'conversions') {
      totalValue = this.calculateEstimatedConversions(item.total_clicks || 0);
    }

    if (item.start_date && item.end_date && totalValue > 0) {
      this.distributeByDateRange(item.start_date, item.end_date, totalValue, data);
    } else if (totalValue > 0) {
      this.distributeUniformly(totalValue, data);
    }
  }

  distributeByDateRange(startDate: string, endDate: string, totalValue: number, data: number[]) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const currentYear = parseInt(this.getYearFromDate(this.dateFilter.value));

    // Verificar si las fechas están en el año seleccionado
    const startYear = start.getFullYear();
    const endYear = end.getFullYear();

    if (startYear > currentYear || endYear < currentYear) {
      return; // No hay actividad en el año seleccionado
    }

    // Determinar meses activos en el año seleccionado
    let startMonth = 0;
    let endMonth = 11;

    if (startYear === currentYear) {
      startMonth = start.getMonth();
    }

    if (endYear === currentYear) {
      endMonth = end.getMonth();
    }

    const activeMonths = endMonth - startMonth + 1;

    if (activeMonths <= 0) return;

    // Distribuir el valor entre los meses activos con algo de variación
    for (let month = startMonth; month <= endMonth; month++) {
      if (month >= 0 && month < 12) {
        // Distribución con peso mayor en meses centrales del periodo
        const monthPosition = (month - startMonth) / Math.max(activeMonths - 1, 1);
        const weight = this.calculateMonthWeight(monthPosition, activeMonths);
        const monthValue = Math.round((totalValue / activeMonths) * weight);
        data[month] += Math.max(0, monthValue);
      }
    }

    // Ajustar para que la suma total sea exacta
    this.adjustTotalToMatch(data, totalValue, startMonth, endMonth);
  }

  calculateMonthWeight(position: number, totalMonths: number): number {
    if (totalMonths === 1) return 1;

    // Distribución más realista: menos al inicio y final, más en el medio
    const curve = Math.sin(position * Math.PI);
    return 0.5 + (curve * 0.8); // Entre 0.5 y 1.3
  }

  adjustTotalToMatch(data: number[], targetTotal: number, startMonth: number, endMonth: number) {
    let currentSum = 0;
    for (let i = startMonth; i <= endMonth; i++) {
      currentSum += data[i];
    }

    const diff = targetTotal - currentSum;

    if (diff !== 0) {
      // Distribuir la diferencia entre los meses activos
      const monthsToAdjust = endMonth - startMonth + 1;
      const adjustmentPerMonth = Math.floor(Math.abs(diff) / monthsToAdjust);
      const remainder = Math.abs(diff) % monthsToAdjust;

      for (let i = startMonth; i <= endMonth; i++) {
        const adjustment = adjustmentPerMonth + (i - startMonth < remainder ? 1 : 0);
        data[i] += diff > 0 ? adjustment : -adjustment;
        data[i] = Math.max(0, data[i]); // No valores negativos
      }
    }
  }

  distributeUniformly(totalValue: number, data: number[]) {
    const baseValue = totalValue / 12;

    for (let i = 0; i < 12; i++) {
      const variation = (Math.random() - 0.5) * 0.6;
      const monthValue = Math.max(0, Math.round(baseValue * (1 + variation)));
      data[i] = monthValue;
    }

    // Ajustar para que la suma total sea exacta
    const currentSum = data.reduce((sum, val) => sum + val, 0);
    if (currentSum !== totalValue && totalValue > 0) {
      const diff = totalValue - currentSum;
      for (let i = 0; i < Math.abs(diff) && i < 12; i++) {
        data[i] += diff > 0 ? 1 : -1;
        data[i] = Math.max(0, data[i]);
      }
    }
  }

  getYearFromDate(dateValue: any): string {
    if (typeof dateValue === 'string' && dateValue.length > 4) {
      return dateValue.split(' ')[3];
    }
    return dateValue.toString();
  }

  onOpenCalendar(container: any) {
    try {
      if (container && container.setViewMode) {
        container.yearSelectHandler = (event: any): void => {
          container._store.dispatch(container._actions.select(event.date));
        };
        container.setViewMode('year');
      } else if (container && container._datePicker) {
        container._datePicker.setViewMode('year');
      } else {
        console.log('Datepicker container no tiene método setViewMode');
      }
    } catch (error) {
      console.error('Error opening calendar:', error);
    }
  }
  // Método mejorado para generar gráficas con mejor detección de elementos
  generateCharts() {
    console.log('Generando gráficas...', this.analyticsData);

    if (!this.analyticsData || typeof Chart === 'undefined') {
      console.log('Chart.js no disponible o sin datos');
      return;
    }

    this.destroyExistingCharts();

    const impressionsData = this.processMonthlyData(this.analyticsData, 'impressions');
    const clicksData = this.processMonthlyData(this.analyticsData, 'clicks');
    const conversionsData = this.processMonthlyData(this.analyticsData, 'conversions');

    console.log('Datos procesados:', {
      impressions: impressionsData,
      clicks: clicksData,
      conversions: conversionsData,
      chartSelection: this.chartSelection
    });

    // Esperar a que el DOM esté listo antes de crear las gráficas
    setTimeout(() => {
      this.initializeCharts(impressionsData, clicksData, conversionsData);
    }, 100);
  }

  // Método mejorado para inicializar gráficas con mejor validación de canvas
  initializeCharts(impressionsData: number[], clicksData: number[], conversionsData: number[]) {
    const commonOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false
          }
        }],
        yAxes: [{
          stacked: true,
          gridLines: {
            color: 'rgb(208, 202, 223)'
          },
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

    const isBannerData = this.summaryMetrics.dataType === 'banners';
    const impressionsLabel = isBannerData ? 'Usuarios Únicos' : 'Cantidad de Vistas';

    try {
      // Gráfica de vistas/usuarios únicos
      if (this.chartSelection === 1) {
        const canvas = document.getElementById('chartImpresiones') as HTMLCanvasElement;
        console.log('Canvas Impresiones encontrado:', !!canvas, canvas);

        if (canvas && canvas.getContext) {
          const ctx = canvas.getContext('2d');
          if (ctx) {
            // Limpiar el canvas antes de crear nueva gráfica
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            this.impressionsChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: this.meses,
                datasets: [{
                  data: impressionsData,
                  label: impressionsLabel,
                  backgroundColor: '#61c4ff',
                  borderColor: 'white',
                  borderWidth: 1
                }]
              },
              options: commonOptions
            });
            console.log('Gráfica de impresiones creada exitosamente');
          } else {
            console.error('No se pudo obtener el contexto 2D del canvas de impresiones');
          }
        } else {
          console.error('Canvas de impresiones no encontrado o no válido');
        }
      }

      // Gráfica de clics
      if (this.chartSelection === 2) {
        const canvas = document.getElementById('chartClicks') as HTMLCanvasElement;
        console.log('Canvas Clicks encontrado:', !!canvas, canvas);

        if (canvas && canvas.getContext) {
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            this.clicksChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: this.meses,
                datasets: [{
                  data: clicksData,
                  label: 'Cantidad de Clics',
                  backgroundColor: '#89d3ff',
                  borderColor: 'white',
                  borderWidth: 1
                }]
              },
              options: commonOptions
            });
            console.log('Gráfica de clicks creada exitosamente');
          } else {
            console.error('No se pudo obtener el contexto 2D del canvas de clicks');
          }
        } else {
          console.error('Canvas de clicks no encontrado o no válido');
        }
      }

      // Gráfica de conversiones
      if (this.chartSelection === 3) {
        const canvas = document.getElementById('chartConversiones') as HTMLCanvasElement;
        console.log('Canvas Conversiones encontrado:', !!canvas, canvas);

        if (canvas && canvas.getContext) {
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const lineOptions = {
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: false
              },
              scales: {
                xAxes: [{
                  gridLines: {
                    display: false
                  }
                }],
                yAxes: [{
                  gridLines: {
                    color: 'rgb(208, 202, 223)'
                  },
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            };

            this.conversionChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: this.meses,
                datasets: [{
                  data: conversionsData,
                  label: 'Conversiones',
                  backgroundColor: 'rgba(69, 44, 128, 0.1)',
                  borderColor: '#452c80',
                  borderWidth: 2,
                  fill: true
                }]
              },
              options: lineOptions
            });
            console.log('Gráfica de conversiones creada exitosamente');
          } else {
            console.error('No se pudo obtener el contexto 2D del canvas de conversiones');
          }
        } else {
          console.error('Canvas de conversiones no encontrado o no válido');
        }
      }
    } catch (error) {
      console.error('Error creating charts:', error);
    }
  }

  // Método mejorado para cambio de gráfica con mejor sincronización
  changeChart(chartType: number) {
    console.log('Cambiando a gráfica tipo:', chartType);
    this.chartSelection = chartType;

    // Esperar a que Angular actualice la vista antes de crear la gráfica
    setTimeout(() => {
      if (this.analyticsData) {
        this.generateCharts();
      } else {
        console.log('No hay datos para generar gráficas');
      }
    }, 150); // Timeout ligeramente mayor para asegurar que el DOM se actualice
  }

  // Método mejorado para cargar analíticas con mejor manejo de estados
  loadAnalytics() {
    console.log('=== INICIANDO CARGA DE ANALYTICS ===');
    this.showLoading = true;

    const analyticsType = this.analyticsTypeFilter.value;
    const elementId = this.elementFilter.value;
    const year = this.getYearFromDate(this.dateFilter.value);

    console.log('Parámetros de filtro:', {
      analyticsType,
      elementId,
      year,
      currentElementList: this.currentElementList.length
    });

    let apiCall;

    if (analyticsType === 'popups') {
      apiCall = this.loadPopupAnalytics(elementId, year);
    } else {
      apiCall = this.loadBannerAnalytics(elementId, year);
    }

    apiCall.subscribe(
      (data: any) => {
        console.log('=== DATOS RECIBIDOS DE API ===', data);

        // Validar que los datos no estén vacíos
        if (!data) {
          console.warn('API devolvió datos vacíos');
          this.initializeDefaultMetrics();
          this.showLoading = false;
          return;
        }

        this.processAnalyticsData(data);
        console.log('=== MÉTRICAS PROCESADAS ===', this.summaryMetrics);

        setTimeout(() => {
          this.generateCharts();
          this.showLoading = false;
          console.log('=== CARGA COMPLETA ===');
        }, 100);
      },
      error => {
        console.error('=== ERROR EN API ===', error);
        this.loadSampleData();
        this.showLoading = false;
      }
    );

  }
  // Método mejorado para detectar cambios en filtros
  initializeFilters() {
    // Suscribirse a cambios en los filtros con debounce
    this.analyticsTypeFilter.valueChanges.subscribe(() => {
      console.log('Cambio en tipo de analítica:', this.analyticsTypeFilter.value);
      this.onTypeChange();
    });

    this.elementFilter.valueChanges.subscribe(() => {
      console.log('Cambio en elemento:', this.elementFilter.value);
      // Pequeño delay para asegurar que el DOM se actualice
      setTimeout(() => {
        this.loadAnalytics();
      }, 50);
    });

    this.dateFilter.valueChanges.subscribe(() => {
      console.log('Cambio en fecha:', this.dateFilter.value);
      setTimeout(() => {
        this.loadAnalytics();
      }, 50);
    });
  }

  // Método mejorado para cambio de tipo
  onTypeChange() {
    console.log('=== CAMBIO DE TIPO ===');
    this.elementFilter.setValue('all');
    this.updateCurrentElementList();

    // Resetear datos para evitar mostrar datos incorrectos
    this.analyticsData = {};
    this.summaryMetrics = {};

    // Forzar actualización
    setTimeout(() => {
      this.loadAnalytics();
    }, 100);
  }

  // Método para validar si el canvas existe antes de crear gráficas
  private validateCanvas(canvasId: string): HTMLCanvasElement | null {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;

    if (!canvas) {
      console.error(`Canvas ${canvasId} no encontrado`);
      return null;
    }

    if (!canvas.getContext) {
      console.error(`Canvas ${canvasId} no soporta contexto 2D`);
      return null;
    }

    // Verificar que el canvas tenga dimensiones
    if (canvas.offsetWidth === 0 || canvas.offsetHeight === 0) {
      console.warn(`Canvas ${canvasId} tiene dimensiones cero:`, {
        width: canvas.offsetWidth,
        height: canvas.offsetHeight
      });
    }

    return canvas;
  }

  // Método para forzar re-renderización
  private forceRerender() {
    // Marcar para detección de cambios
    setTimeout(() => {
      if (this.analyticsData && Object.keys(this.analyticsData).length > 0) {
        console.log('Forzando re-renderización de gráficas');
        this.generateCharts();
      }
    }, 200);
  }

  // Método mejorado para destruir gráficas con mejor limpieza
  destroyExistingCharts() {
    try {
      if (this.impressionsChart) {
        console.log('Destruyendo gráfica de impresiones');
        this.impressionsChart.destroy();
        this.impressionsChart = null;
      }
      if (this.clicksChart) {
        console.log('Destruyendo gráfica de clicks');
        this.clicksChart.destroy();
        this.clicksChart = null;
      }
      if (this.conversionChart) {
        console.log('Destruyendo gráfica de conversiones');
        this.conversionChart.destroy();
        this.conversionChart = null;
      }

      // Limpiar referencias de Chart.js
      if (typeof Chart !== 'undefined' && Chart.helpers) {
        Chart.helpers.each(Chart.instances, (instance: any) => {
          if (instance.chart && instance.chart.canvas) {
            const canvasId = instance.chart.canvas.id;
            if (['chartImpresiones', 'chartClicks', 'chartConversiones'].includes(canvasId)) {
              console.log(`Limpiando instancia de Chart.js para ${canvasId}`);
              instance.destroy();
            }
          }
        });
      }

    } catch (error) {
      console.error('Error destroying charts:', error);
    }
  }
}

